import Vue from 'vue'
import VueResource from 'vue-resource'
import VueRaven from 'vue-raven'
import { Loading, Select, Option, Row, Col, Tabs, TabPane, Switch } from 'element-ui'
import locale from 'element-ui/lib/locale'
import langPl from 'element-ui/lib/locale/lang/pl'
import 'element-ui/lib/theme-chalk/index.css'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/eclipse.css'
import 'codemirror/theme/rubyblue.css'
import App from './App.vue'
import router from './router'
import store from './vuex/store'
import i18n from './i18n'

Vue.config.productionTip = false

locale.use(langPl)
Vue.use(Loading)
Vue.use(Select)
Vue.use(Option)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Switch)
Vue.use(VueResource)
if (process.env.VUE_APP_ENV === 'production') {
  Vue.use(VueRaven, {
    dsn: process.env.VUE_APP_SENTRY,
    environment: process.env.VUE_APP_ENV
  })
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
